import React from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";

import Table from "./Table";
import useDeepMemo from "../hooks/useDeepMemo";
import { isEmpty } from "../utils/helpers";

const colList = [
  { dataKey: "row", title: "Row" },
  { dataKey: "column", title: "Column" },
  { dataKey: "message", title: "Error Message" }
];

const ErrorDialog = ({ open, columns, errors, onClose, maxWidth = "md" }) => {
  const columnList = useDeepMemo(() => {
    if (isEmpty(columns)) return colList;
    return columns;
  }, [columns]);

  return (
    <Dialog id="error-dialog-container" fullWidth={true} maxWidth={maxWidth} open={open} onClose={onClose}>
      <DialogTitle id="error-dialog-title">Errors</DialogTitle>
      <Divider />
      <DialogContent id="error-dialog-content" style={{ padding: 0 }}>
        {errors && <Table columns={columnList} rows={errors.map(e => ({ ...e, row: `Row ${e.row}` }))} />}
      </DialogContent>
      <DialogActions id="dialog-actions" style={{ padding: "1em" }}>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
